import * as React from 'react';
import {StyleProp, ViewStyle, Animated} from 'react-native';
import {useStyles} from '../../hooks/styles';

const viewMovement = 40;
const animationDuration = 300;

interface Props {
  isActive: boolean;
  style?: StyleProp<ViewStyle>;
}

export const RisingView: React.FC<Props> = ({isActive, style, children}) => {
  const viewTranslateY = React.useRef(new Animated.Value(viewMovement)).current;
  const viewOpacity = React.useRef(new Animated.Value(0)).current;
  const [isVisible, setVisible] = React.useState(isActive);

  const styles = useStyles(() => ({
    invisible: {
      position: 'absolute',
      maxHeight: 0,
      maxWidth: 0,
      opacity: 0,
      display: 'none',
    },
  }));

  React.useEffect(() => {
    if (!isVisible) {
      return;
    }
    Animated.parallel([
      Animated.timing(viewTranslateY, {
        toValue: isActive ? 0 : viewMovement,
        duration: animationDuration,
        useNativeDriver: true,
      }),
      Animated.timing(viewOpacity, {
        toValue: isActive ? 1 : 0,
        duration: animationDuration,
        useNativeDriver: true,
      }),
    ]).start(({finished}) => {
      if (finished && !isActive) {
        setVisible(false);
      }
    });
  }, [isActive, isVisible]);

  React.useEffect(() => {
    if (isActive) {
      setVisible(true);
    }
  }, [isActive]);

  return (
    <Animated.View
      style={[
        isVisible ? style : styles.invisible,
        {
          transform: [{translateY: viewTranslateY}],
          opacity: viewOpacity,
        },
      ]}>
      {children}
    </Animated.View>
  );
};
